
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"461","height":"461","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero","fill":"#0095DA"}},[_c('path',{attrs:{"d":"M451.138 164.19L296.588 9.64c-12.858-12.86-32.992-12.847-45.84 0L9.657 250.733C3.33 257.059-.188 265.747.007 274.56c.185 8.54 3.683 16.42 9.857 22.224l32.917 32.918c5.7 5.712 14.72 6.374 21.199 1.585 18.902-13.96 45.21-12.14 61.2 4.252 16.383 16.784 18.376 43.152 4.633 61.338a16.284 16.284 0 001.476 21.34l33.123 33.123c6.164 6.157 14.558 9.66 23.137 9.66.228 0 .462-.005.69-.01 8.541-.185 16.42-3.677 22.225-9.857l240.88-240.898c6.326-6.32 9.84-15.003 9.649-23.82-.185-8.542-3.676-16.42-9.855-22.226zM274 32.505c-.075.043-.2.064-.304.086l-11.424-11.424L274 32.506zm-86.662 395.68l-23.952-23.951c14.612-29.621 9.177-66.79-14.89-91.453-23.983-24.555-61.336-30.115-91.69-15.128l-23.995-23.99 240.864-240.86 154.52 154.522-240.857 240.86z"}}),_c('path',{attrs:{"d":"M193.095 88.014l23.179-22.882 41.805 42.346-23.18 22.883zM331.198 226.612l22.887-23.187 42.359 41.811-22.887 23.187zM262.134 157.04l23.033-23.032 42.349 42.349-23.033 23.033z"}})])])
          )
        }
      }
    